import React from 'react';
import { Pill } from './ChipsUsed';
import { getChipMeta } from '../UI/chipMeta';
import { FaSearch } from 'react-icons/fa';
import { ChipName } from '../../types';
import SegmentedControl from '../UI/SegmentedControl';

export const ChipsUsedControls: React.FC<{
  query: string;
  setQuery: (q: string) => void;
  filter: ChipName | 'all';
  setFilter: (f: ChipName | 'all') => void;
  sort: 'name' | 'count' | 'recent';
  setSort: (s: 'name' | 'count' | 'recent') => void;
}> = ({ query, setQuery, filter, setFilter, sort, setSort }) => (
  <div className="grid grid-cols-1 gap-3 md:grid-cols-3 md:items-center mb-4">
    <div className="flex min-h-11 items-center gap-2 bg-surface rounded-xl px-3 py-2 ring-1 ring-line">
      <FaSearch className="text-content-muted" />
      <label htmlFor="chip-search" className="sr-only">Search manager or team ID</label>
      <input
        id="chip-search"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        placeholder="Search manager or team ID…"
        className="min-h-11 bg-transparent outline-none w-full text-sm text-content placeholder:text-content-muted"
      />
    </div>
    <div className="flex flex-wrap gap-2">
      <Pill active={filter === 'all'} onClick={() => setFilter('all')} title="Show all">
        All chips
      </Pill>
      {(['wildcard', 'freehit', 'bboost', '3xc'] as ChipName[]).map((c) => {
        const { Icon, label } = getChipMeta(c);
        return (
          <Pill
            key={c}
            active={filter === c}
            onClick={() => setFilter(c)}
            title={`Filter: ${label}`}
          >
            <div className="flex items-center gap-2">
              <Icon />
              <span className="hidden sm:inline">{label}</span>
              <span className="sm:hidden capitalize">{c}</span>
            </div>
          </Pill>
        );
      })}
    </div>
    <div className="flex items-center gap-2 justify-start md:justify-end">
      <span className="text-sm text-content-secondary">Sort:</span>
      <SegmentedControl
        options={[
          { value: 'recent', label: 'Most recent' },
          { value: 'count', label: 'Most used' },
          { value: 'name', label: 'A–Z' },
        ]}
        value={sort}
        onChange={setSort}
      />
    </div>
  </div>
);
